

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { FormationForListViewModel } from '../models/FormationForListViewModel';
import { SessionFormationTotalStatutModel } from '../models/SessionFormationTotalStatutModel';
import { SessionFormationEditModel } from '../models/SessionFormationEditModel';
import { NationalRegionalFormationModel } from '../models/NationalRegionalFormationModel';
import { ClassificationFormationModel } from '../models/ClassificationFormationModel';
import { TypeSessionFormationModel } from '../models/TypeSessionFormationModel';
import { SourceFormationModel } from '../models/SourceFormationModel';
import { FinancementModel } from '../models/FinancementModel';
import { IdOrdreModel } from '../models/IdOrdreModel';
import { MontagneFormationModel } from '../models/MontagneFormationModel';
import { MontagneDiplomeModel } from '../models/MontagneDiplomeModel';
import { MontagneCursusModel } from '../models/MontagneCursusModel';

@Injectable({
   providedIn: 'root'
})
export class SessionFormationApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/SessionFormation/getListSessionFormation?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&annee=${annee}&siteId=${siteId}&isForomes=${isForomes}&globalFilter=${encodeURIComponent(globalFilter)}&isStatutValide=${isStatutValide}
    getListSessionFormation(first: number, rows: number, sortField: string, sortOrder: number, total: number, annee: number, siteId: number, isForomes: boolean, globalFilter: string, isStatutValide: number): Observable<FormationForListViewModel> {
        var _Url = `api/SessionFormation/getListSessionFormation?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&annee=${annee}&siteId=${siteId}&isForomes=${isForomes}&globalFilter=${encodeURIComponent(globalFilter)}&isStatutValide=${isStatutValide}`;
            return this._httpClient.get<FormationForListViewModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getSessionFormationTotalByStatut?annee=${annee}&siteId=${siteId}&isForomes=${isForomes}
    getSessionFormationTotalByStatut(annee: number, siteId: number, isForomes: boolean): Observable<SessionFormationTotalStatutModel> {
        var _Url = `api/SessionFormation/getSessionFormationTotalByStatut?annee=${annee}&siteId=${siteId}&isForomes=${isForomes}`;
            return this._httpClient.get<SessionFormationTotalStatutModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getSessionFormation?sessionFormationId=${sessionFormationId}
    getSessionFormation(sessionFormationId: number): Observable<SessionFormationEditModel> {
        var _Url = `api/SessionFormation/getSessionFormation?sessionFormationId=${sessionFormationId}`;
            return this._httpClient.get<SessionFormationEditModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getNewSessionFormation?etablissementId=${etablissementId}
    getNewSessionFormation(etablissementId: number): Observable<SessionFormationEditModel> {
        var _Url = `api/SessionFormation/getNewSessionFormation?etablissementId=${etablissementId}`;
            return this._httpClient.get<SessionFormationEditModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/save
    save(formation: SessionFormationEditModel): Observable<SessionFormationEditModel> {
        var _Url = `api/SessionFormation/save`;
            return this._httpClient.post<SessionFormationEditModel>(_Url, formation).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/delete?id=${id}
    delete(id: number): Observable<boolean> {
        var _Url = `api/SessionFormation/delete?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getAnneesAvecFormation?isForomes=${isForomes}
    getAnneesAvecFormation(isForomes: boolean): Observable<number[]> {
        var _Url = `api/SessionFormation/getAnneesAvecFormation?isForomes=${isForomes}`;
            return this._httpClient.get<number[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getAnneesForNewFormation
    getAnneesForNewFormation(): Observable<number[]> {
        var _Url = `api/SessionFormation/getAnneesForNewFormation`;
            return this._httpClient.get<number[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getNationalRegionalFormations
    getNationalRegionalFormations(): Observable<NationalRegionalFormationModel[]> {
        var _Url = `api/SessionFormation/getNationalRegionalFormations`;
            return this._httpClient.get<NationalRegionalFormationModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getClassificationFormations
    getClassificationFormations(): Observable<ClassificationFormationModel[]> {
        var _Url = `api/SessionFormation/getClassificationFormations`;
            return this._httpClient.get<ClassificationFormationModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getTypeSessionFormations
    getTypeSessionFormations(): Observable<TypeSessionFormationModel[]> {
        var _Url = `api/SessionFormation/getTypeSessionFormations`;
            return this._httpClient.get<TypeSessionFormationModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getSourceFormations
    getSourceFormations(): Observable<SourceFormationModel[]> {
        var _Url = `api/SessionFormation/getSourceFormations`;
            return this._httpClient.get<SourceFormationModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getExportFormationsDownload
    getExportFormationsDownload(): Observable<HttpResponse<Blob>> {
        var _Url = `api/SessionFormation/getExportFormationsDownload`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/SessionFormation/getFinancements
    getFinancements(): Observable<FinancementModel[]> {
        var _Url = `api/SessionFormation/getFinancements`;
            return this._httpClient.get<FinancementModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveTypeSessionFormation
    saveTypeSessionFormation(typeSessionFormationEdit: TypeSessionFormationModel): Observable<TypeSessionFormationModel> {
        var _Url = `api/SessionFormation/saveTypeSessionFormation`;
            return this._httpClient.post<TypeSessionFormationModel>(_Url, typeSessionFormationEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/deleteTypeSessionFormation?id=${id}
    deleteTypeSessionFormation(id: number): Observable<boolean> {
        var _Url = `api/SessionFormation/deleteTypeSessionFormation?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveOrdreTypeSessionFormation
    saveOrdreTypeSessionFormation(typeSessionFormations: IdOrdreModel[]): Observable<boolean> {
        var _Url = `api/SessionFormation/saveOrdreTypeSessionFormation`;
            return this._httpClient.post<boolean>(_Url, typeSessionFormations).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveMontagneFormation?typeSessionFormationId=${typeSessionFormationId}
    saveMontagneFormation(montagneFormationEdit: MontagneFormationModel, typeSessionFormationId: number): Observable<MontagneFormationModel> {
        var _Url = `api/SessionFormation/saveMontagneFormation?typeSessionFormationId=${typeSessionFormationId}`;
            return this._httpClient.post<MontagneFormationModel>(_Url, montagneFormationEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/deleteMontagneFormation?id=${id}
    deleteMontagneFormation(id: number): Observable<boolean> {
        var _Url = `api/SessionFormation/deleteMontagneFormation?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveOrdreMontagneFormation
    saveOrdreMontagneFormation(montagneFormations: IdOrdreModel[]): Observable<boolean> {
        var _Url = `api/SessionFormation/saveOrdreMontagneFormation`;
            return this._httpClient.post<boolean>(_Url, montagneFormations).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveMontagneDiplome?montagneFormationId=${montagneFormationId}
    saveMontagneDiplome(montagneDiplomeEdit: MontagneDiplomeModel, montagneFormationId: number): Observable<MontagneDiplomeModel> {
        var _Url = `api/SessionFormation/saveMontagneDiplome?montagneFormationId=${montagneFormationId}`;
            return this._httpClient.post<MontagneDiplomeModel>(_Url, montagneDiplomeEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/deleteMontagneDiplome?id=${id}
    deleteMontagneDiplome(id: number): Observable<boolean> {
        var _Url = `api/SessionFormation/deleteMontagneDiplome?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveOrdreMontagneDiplome
    saveOrdreMontagneDiplome(montagneDiplomes: IdOrdreModel[]): Observable<boolean> {
        var _Url = `api/SessionFormation/saveOrdreMontagneDiplome`;
            return this._httpClient.post<boolean>(_Url, montagneDiplomes).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveMontagneCursus?montagneDiplomeId=${montagneDiplomeId}
    saveMontagneCursus(montagneCursusEdit: MontagneCursusModel, montagneDiplomeId: number): Observable<MontagneCursusModel> {
        var _Url = `api/SessionFormation/saveMontagneCursus?montagneDiplomeId=${montagneDiplomeId}`;
            return this._httpClient.post<MontagneCursusModel>(_Url, montagneCursusEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/deleteMontagneCursus?id=${id}
    deleteMontagneCursus(id: number): Observable<boolean> {
        var _Url = `api/SessionFormation/deleteMontagneCursus?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/SessionFormation/saveOrdreMontagneCursus
    saveOrdreMontagneCursus(montagneCursus: IdOrdreModel[]): Observable<boolean> {
        var _Url = `api/SessionFormation/saveOrdreMontagneCursus`;
            return this._httpClient.post<boolean>(_Url, montagneCursus).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
